var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSexualOrgans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sexual Organs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-40",
    transform: "translate(-209.000000, -188.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9393823,155.104958 C40.3446756,155.104958 40.7829839,155.186856 41.1677401,155.104958 C41.3019997,155.07638 41.8796546,160.131534 42.0108863,160.093592 C44.834662,159.27718 46.925902,156.329454 46.925902,152.818148 C46.925902,148.676013 44.0157528,145.318148 40.425902,145.318148 C36.8360511,145.318148 33.925902,148.676013 33.925902,152.818148 C33.925902,156.483201 36.2042872,159.534241 39.215946,160.188445 C39.6079758,160.273603 39.5259107,155.104958 39.9393823,155.104958 Z",
    id: "Sexual-Organs"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSexualOrgans);
export default __webpack_public_path__ + "static/media/SexualOrgans.6845f5452a4b8ae588e23a4c3a86ee74.svg";
export { ForwardRef as ReactComponent };